

import React, { useEffect, useState } from "react";
import { Table, Card, CardHeader, CardBody, Row, Col, CardTitle, Button } from "reactstrap";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import TMHLoader from "../TMHLoader/TMHLoader";

export default function ActivePlayerAnalyticsTable() {
    const { token } = useToken()
    const { timeZone } = useTimeZone()
    const [isLoading, setIsLoading] = useState(false)
    const [numberOfWeeks, setNumberOfWeeks] = useState(4)
    const [reportArr, setReportArr] = useState()

    function getMonday(d) {
        var day = d.getDay(),
            diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    }
    const getDateStr = (dateObj) => {
        dateObj = getMonday(dateObj)
        console.log(dateObj)
        var year = dateObj.getFullYear()
        var month = dateObj.getMonth() + 1
        var day = dateObj.getDate()

        if (month < 10) month = "0" + String(month)
        if (day < 10) day = "0" + + String(day)

        var res = year + '-' + month + '-' + day
        return res
    }
    const date = new Date();
    const [startDate, setStartDate] = useState(getDateStr(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 21)))

    useEffect(() => {
        const initData = () => {
            setIsLoading(true)
            console.log('ActivePlayerAnalyticsTable: get data')
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };

            const params = new URLSearchParams({
                'timezone_offset_minutes': timeZone * -60,
                'start_date': startDate,
                'num_of_weeks': numberOfWeeks
            });
            fetch(process.env.REACT_APP_BASE_URL + "analytics/active_users_report?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        // console.log(json)
                        if (result.ok) {
                            setReportArr(json.data)
                        }
                        else {

                        }
                        setIsLoading(false)
                    }
                )
        }

        initData()
    }, [numberOfWeeks, startDate, timeZone, token])


    const exportCsv = () => {
        console.log('exportCsv')
        // setIsLoading(true)
        // var myHeaders = new Headers();
        // myHeaders.append("Cache-Control", "no-cache");
        // myHeaders.append("Access-Token", token);

        // var requestOptions = {
        //     method: 'GET',
        //     headers: myHeaders,
        // }

        // const params = new URLSearchParams({
        //     'timezone_offset_minutes': timeZone * -60,
        //     'start_date': dateRangeState.startDate.toLocaleDateString("en-US", {
        //         weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
        //     }),
        //     'num_of_weeks': 3
        // });

        // fetch(process.env.REACT_APP_BASE_URL + "analytics/active_users_report/export_csv?" + params, requestOptions)
        //     .then((response) => {
        //         return new Promise((resolve) => response.blob()
        //             .then((blob) => resolve({
        //                 status: response.status,
        //                 ok: response.ok,
        //                 blob,
        //             })))
        //     }).then(
        //         async (result) => {
        //             var blob = result.blob
        //             if (result.ok) {
        //                 setIsLoading(false)
        //                 var file = window.URL.createObjectURL(blob, 'csv');
        //                 // window.location.assign(file);
        //                 var anchor = document.createElement("a");
        //                 anchor.download = "mins_report.csv";
        //                 anchor.href = file;
        //                 anchor.click();
        //             }
        //             else {
        //                 console.log(result.json.message)
        //                 setIsLoading(false)
        //             }
        //         }
        //     ).catch(function () {
        //         console.log("error");
        //         setIsLoading(false)
        //     });
    }

    return (

        <TMHLoader active={isLoading}>
            <Card>
                <CardHeader>
                    <CardTitle className="text-left" tag="h2">
                        <Row>
                            <Col md="4">
                                Active User Report
                            </Col>
                            <Col tag="h4" md=".">
                                Start Date: {" "}
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Col>
                            <Col md="1" />
                            <Col tag="h4" md="3">
                                Number Weeks: {" "}
                                <select
                                    style={{width: 50}}
                                    value={numberOfWeeks}
                                    onChange={(e) => setNumberOfWeeks(e.target.value)}
                                >
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                </select>
                            </Col>
                            <Col md="2" tag="h4">
                                Export {" "}
                                <Button onClick={() => exportCsv()} className="btn-icon btn-simple" color="success" size="sm">
                                    <i className="fa-solid fa-file-export" />
                                </Button>
                            </Col>
                        </Row>
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <Row>
                        {
                            reportArr && ["All", "MobileApp", "FreeMovieHouse", "FreeMovieSpin"].map((method) =>
                                <Col md="12">
                                    <Card>
                                        <CardHeader tag="h4">Method: {method}</CardHeader>
                                        <CardBody>
                                            <Table style={{color: "0xffffff"}}>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        {
                                                            reportArr.map((reportData, index) => 
                                                                <th>
                                                                    Week {index + 1} ({reportData.start_date.substring(4, 11) 
                                                                    + " => " 
                                                                    + reportData.end_date.substring(4, 11)})
                                                                </th>
                                                            )
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th>SignUps</th>
                                                        {
                                                            reportArr.map((reportData, _) => 
                                                            <td>{reportData[method].signup}</td>
                                                            )
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th>RokuIds</th>
                                                        {
                                                            reportArr.map((reportData, _) => 
                                                            <td>{reportData[method].channel_client_id}</td>
                                                            )
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th>Active User ({'>'}1mins)</th>
                                                        {
                                                            reportArr.map((reportData, _) => 
                                                            <td>{reportData[method].active_user}</td>
                                                            )
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th>Mins Total</th>
                                                        {
                                                            reportArr.map((reportData, _) => 
                                                            <td>{reportData[method].mins_total}</td>
                                                            )
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th>Mins Avg</th>
                                                        {
                                                            reportArr.map((reportData, _) => 
                                                            <td>{reportData[method].active_user > 0 ? (reportData[method].mins_total / reportData[method].active_user).toFixed(2) : 0}</td>
                                                            )
                                                        }
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </CardBody>
                                    </Card>
                                </Col>
                            )
                        }

                    </Row>
                </CardBody>
            </Card>
        </TMHLoader>
    );
}